export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8 4a4 4 0 00-4 4v24a4 4 0 004 4h24a4 4 0 004-4V8a4 4 0 00-4-4H8zM6 8a2 2 0 012-2h24a2 2 0 012 2v24a2 2 0 01-2 2H8a2 2 0 01-2-2V8zm7 4a1 1 0 00-1 1v14a1 1 0 001 1h14a1 1 0 001-1V13a1 1 0 00-1-1H13zm1 14V14h12v12H14zm7.903-9.125a1 1 0 00-1.56 1.25C20.753 18.64 21 19.29 21 20s-.246 1.36-.658 1.875a1 1 0 001.56 1.25A4.983 4.983 0 0023 20c0-1.181-.411-2.27-1.097-3.125zm-3.653 1.14a1 1 0 10-1.5 1.324c.156.177.25.407.25.661a.995.995 0 01-.25.661 1 1 0 101.5 1.324c.466-.529.75-1.225.75-1.985s-.284-1.456-.75-1.985zM16 32a1 1 0 100-2 1 1 0 000 2zm4 0a1 1 0 100-2 1 1 0 000 2zm5-1a1 1 0 11-2 0 1 1 0 012 0z\" fill=\"#000\"/>",
  "attrs": {
    "width": "40",
    "height": "40",
    "viewBox": "0 0 40 40",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};